module.exports = __webpack_public_path__ + "img/2_CNC_2_y_3.cb894cf1.jpg";